import { createStore, applyMiddleware, compose } from 'redux'
import logger from 'redux-logger'
import thunk from 'redux-thunk'
import { middleware as authMiddleware } from 'auth'
import { middleware as chatMiddleware } from 'chat'
import { middleware as analyticsMiddleware } from 'analytics'
import { middleware as errorMiddleware } from 'errors'
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'
import persistState from 'redux-localstorage'

import config from 'config'
import rootReducer from './rootReducer'
import localstorageSlicer from './localstorageSlicer'

// Anything short of real production: dev, and any deployed non-production
// environment (staging, etc.) via NODE_ENV. The extension itself is opt-in
// per browser, so this is a no-op for anyone without it installed.
//
// `config.reduxDevTools` is only defined in config/development.json — every
// other env config (staging.json, production.json, ...) omits the key. The
// extension's own compose() only handles an `undefined` first argument
// correctly when it receives *zero* arguments, not one that resolves to
// undefined; passing it explicitly derails its internal enhancer chain and
// throws ("a is not a function") deep inside the extension's own bundle.
// `|| {}` keeps this env-independent instead of patching every config file.
const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(config.reduxDevTools || {})
    : compose

const store = createStore(
  rootReducer,
  composeEnhancers(
    persistState(null, {
      slicer: (path) => localstorageSlicer
    }),
    applyMiddleware(
      thunk,
      chatMiddleware,
      authMiddleware,
      analyticsMiddleware,
      errorMiddleware,
      routerMiddleware(browserHistory),
      logger()
    )
  )
)

if (module.hot) {
  module.hot.accept('./rootReducer', () => {
    store.replaceReducer(require('./rootReducer').default)
  })
}

export default store
